import React from "react";

import { Box, TextField, Typography } from "@mui/material";
import type { CardConfig, TextCardConfig } from "store/types";

import { SectionLabel } from "./SectionLabel";

interface Props {
  config: TextCardConfig;
  onUpdateConfig: (c: CardConfig) => void;
}

export const TextSettings: React.FC<Props> = ({ config, onUpdateConfig }) => {
  return (
    <Box>
      <SectionLabel>Text Content</SectionLabel>
      <TextField
        fullWidth
        multiline
        rows={8}
        value={config.content}
        onChange={(e) => onUpdateConfig({ ...config, content: e.target.value })}
        placeholder="Enter your text content here..."
        sx={{
          "& .MuiInputBase-input": { fontSize: 12, lineHeight: 1.5 },
          "& .MuiOutlinedInput-root": { borderRadius: "8px" }
        }}
      />
      <Typography sx={{ fontSize: 11, color: "#9CA3AF", mt: 1 }}>
        Enter plain text content for your card. You can also click the card on the canvas to edit directly.
      </Typography>
    </Box>
  );
};
